import React from "react";
import "./MoveOptionsCard.scss"
import { MovePaperWorkCard } from "components/movePaperWorkCard";
import { MoveListCard } from "components/moveListCard";
import { Button } from "components/button";
import { EstimatorDetailCard } from "components/estimatorDetailCard";
import { OrignCompanyDetailCard } from "components/OrignCompanyDetailCard";
import { CompanyDetailCard } from "components/companyDetailCard";
import { DestinationCompanyDetailCard } from "components/DestinationCompanyDetailCard";
import { InfoCard } from "components/infoCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { navigate } from "@reach/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
import { title } from "process";
import { FormControl, InputLabel, OutlinedInput, TextField } from "@material-ui/core";
//import { sign } from "crypto";

export interface MoveOptionsCardProps {

}

export interface MoveOptionsCardState {
    loading: boolean
    data: any
    EstimatorDetails: any
}


class MoveOptionsCard extends React.Component<MoveOptionsCardProps, MoveOptionsCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;

    constructor(props: MoveOptionsCardProps) {
        super(props);
        //debugger;
        this.state = {
            loading: false,
            EstimatorDetails: [],
            data: {
                t: "$6000",
                p: "$560",
                m: "$45678"
            }


        };


    }


    componentDidMount() {

        console.log("componentDidMount")
        var est = JSON.parse(localStorage.getItem("EstimatorDetails") || '[]')
        this.setState({ EstimatorDetails: est })
        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        //this.getData(cid);
        Promise.all([
            //this.getCustomerDetails(cid),
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid)
        ]).then((response: any[]) => {
            if (this._isMounted) {

            }
        });
        //this.setState({loading:false});
    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }


    render() {
        const textFieldStyles = {
            '& .MuiOutlinedInput-root': {
                border: 0,
                '&:before': {
                    border: 'none !important',
                },
                '&:after': {
                    border: 'none !important',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent !important',
                },
            },
        }

        return (
            <div className="cardContainer">

                <CardLayout>
                    <div className="optionContent">
                        <h1>Option 1</h1>
                        <h2>AMS Protection Plan</h2>
                        <p>Full Replacement Value Protection</p>
                        <h4><span>This cost estimate includes Full Value Replacement Value Protection based on a valuation amount equal to $6.00 multiplied by the weight (in pounds) of your shipment, subject to a minimum valuation amount of $6,000.00.</span> If any article is lost, destroyed or damaged while in your mover's custody, your mover will, at its option, either 1) repair the article to the extent necessary to restore it to the same condition as when it was received by your mover, or pay you for the cost of such repairs; or 2) replace the article with an article of like kind and quality, or 3) pay you for the cost of such a replacement.</h4>
                        <h4><span>The Default Value of my Shipment is ${this.state.EstimatorDetails.shipmentValue}</span> and the cost of Full Value Protection based on the value I have declared will be included in my total charges. <span className="errorText">(Default Value = $6.00 multiplied by the weight (in pounds) of your shipment & $0 Deductible)</span></h4>
                    </div>
                    <div className="optionContent marginTopText">
                        <h1>Option 2</h1>
                        <h2>WAIVER of Full Value Protection</h2>
                        <h4><span>WAIVER of Full Value Protection.</span> This lower level of protection is provided at no additional cost beyond the
                            base rate; however, it provides only minimal protection that is considerably less than the average value of household goods. Under this option, a claim for any article that may be lost, destroyed, or damaged while in your mover’s custody will be settled  based on the weight of the individual article multiplied by 60 cents. <span>For example, the settlement for an audio component valued  at $1,000 that weighs 10 pounds would be $6.00 (10 pounds times 60 cents).</span></h4>

                    </div>
                    <div className="note">Note: Shipper- You will Select your level of Valuation Liability Protection (Option 1 or 2) the day of your move on your Bill of Lading!</div>
                    <div className="marginTopText">
                        <h3>If you would like to define a higher value for your shipment than above at an additional cost to you, please let your sales agent know. </h3>
                    </div>
                </CardLayout>
                <CardLayout>
                    <div >
                        <InputLabel >Remarks</InputLabel>
                        <TextField
                            id="filled-multiline-static"
                            multiline
                            rows={5}
                            defaultValue=""
                            style={{ background: "#FAFAFA", border: "1px solid #B1B1B1", borderRadius: "8px" }}
                            InputProps={{ disableUnderline: true }}
                            fullWidth
                            placeholder="Additional comments added here"
                        />

                    </div>
                </CardLayout>
            </div>
        );
    }
}

export default MoveOptionsCard;